import React, { useContext } from 'react';
import { defaultContactInfo, IContactInfo } from 'src/entities/company';

export const ContactContext = React.createContext<IContactInfo>(defaultContactInfo);
export const ContactProvider = ContactContext.Provider;
export const ContactConsumer = ContactContext.Consumer;

export const useContactInfo = () => useContext(ContactContext);